import styled from 'styled-components';
import { Overlay } from '@/components/UI/Overlay';

export const DropdownMenu = styled.div<{
  $alignment: 'left' | 'right';
}>`
  display: block;
  position: absolute;
  width: inherit;
  margin-top: 10px;

  ${({ $alignment }) => $alignment === 'left' && 'left: 0'};
  ${({ $alignment }) => $alignment === 'right' && 'right: 0'};
`;

export const DropdownOverlay = styled(Overlay)`
  transition: none;
  z-index: 9;
`;
